"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var hw_app_str_1 = __importDefault(require("@ledgerhq/hw-app-str"));
var errors_1 = require("@ledgerhq/errors");
var deviceAccess_1 = require("../../hw/deviceAccess");
var js_buildTransaction_1 = require("./js-buildTransaction");
var api_1 = require("./api");
var buildOptimisticOperation = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var transactionSequenceNumber, fees, operation;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, api_1.fetchSequence)(account)];
            case 1:
                transactionSequenceNumber = _b.sent();
                fees = (_a = transaction.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0);
                operation = {
                    id: "".concat(account.id, "--OUT"),
                    hash: "",
                    type: "OUT",
                    value: transaction.useAllAmount && transaction.networkInfo
                        ? account.balance.minus(transaction.networkInfo.baseReserve).minus(fees)
                        : transaction.amount.plus(fees),
                    fee: fees,
                    blockHash: null,
                    blockHeight: null,
                    senders: [account.freshAddress],
                    recipients: [transaction.recipient],
                    accountId: account.id,
                    date: new Date(),
                    // FIXME: Javascript number may be not precise enough
                    transactionSequenceNumber: transactionSequenceNumber === null || transactionSequenceNumber === void 0 ? void 0 : transactionSequenceNumber.plus(1).toNumber(),
                    extra: {}
                };
                return [2 /*return*/, operation];
        }
    });
}); };
/**
 * Sign Transaction with Ledger hardware
 */
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return rxjs_1.Observable.create(function (o) {
            function main() {
                return __awaiter(this, void 0, void 0, function () {
                    var unsigned, unsignedPayload, hwApp, signature, operation;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                o.next({
                                    type: "device-signature-requested"
                                });
                                // Fees are loaded during prepareTransaction
                                if (!transaction.fees) {
                                    throw new errors_1.FeeNotLoaded();
                                }
                                return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(account, transaction)];
                            case 1:
                                unsigned = _a.sent();
                                unsignedPayload = unsigned.signatureBase();
                                hwApp = new hw_app_str_1["default"](transport);
                                return [4 /*yield*/, hwApp.signTransaction(account.freshAddressPath, unsignedPayload)];
                            case 2:
                                signature = (_a.sent()).signature;
                                unsigned.addSignature(account.freshAddress, signature.toString("base64"));
                                o.next({
                                    type: "device-signature-granted"
                                });
                                return [4 /*yield*/, buildOptimisticOperation(account, transaction)];
                            case 3:
                                operation = _a.sent();
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: unsigned.toXDR(),
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map